import React, {useState, useEffect} from 'react';
import {Form, Button, Alert, Col} from 'react-bootstrap';
import {Formik} from 'formik';
import {useNavigate, Link, useSearchParams} from 'react-router-dom';
//Redirect
import axios from 'axios';
import {apiUrl} from '../util/Api';
import {setAuthentication, clearAuthentication} from '../util/Auth';

import {useDispatch} from 'react-redux';
import {saveUserStore, clearUserStore} from '../app/slices/UserSlice';

import * as Yup from 'yup';

const validationSchema = Yup.object({
  email: Yup.string().email('please enter a valid email').required('email is required'),
  password: Yup.string().min(8,'passwords need to be at least 8 characters').required('please enter a password')
});

const Login = () => {
  const [errors, setErrors] = useState([]);

  const showPasswordReset = process.env.REACT_APP_ENABLE_RESET === 'true' ? true : false;

  const [searchParams] = useSearchParams();
  const inviteKey = searchParams.get('inviteKey') ? searchParams.get('inviteKey') : null;
  const regKey = searchParams.get('regKey') ? searchParams.get('regKey') : null;

  let params = (inviteKey ? `&inviteKey=${inviteKey}` : '') + (regKey ? `&regKey=${regKey}` : '')

  //TODO see how navigate works - may need to add "replace"
  //https://reactrouter.com/docs/en/v6/upgrading/v5#upgrade-to-react-router-v6
  //redirect push vs navigate replace
  let navigate = useNavigate();

  const dispatch = useDispatch();

  useEffect(()=>{
    //console.log('in login form');
    //clear user on hitting login form for the first time
    clearAuthentication();
    dispatch(clearUserStore());
    document.title = `reconify login`;
  },[dispatch, inviteKey, regKey])

  const submitLogin = (values, actions) => {
    //console.log("submitting form", values);
    setErrors([]);
    //convert value from array here
    //var persist = values.persist ? (values.persist[0] === '1' ? 1 : 0) : 0;
    //console.log('persist:', persist);
    //send value of one instead of 'On' - note added a value to the checkbox in the form
    //values.persist = persist;
    let persist = values.persist ? true : false;
    //console.log('updated values:', values);

    //if partner reg - add to process
    if(regKey != null){
      values.regKey = regKey;
    }

    axios.post(apiUrl + '/login', values, {withCredentials: true})
    .then((res) => {
      //console.log('logged in');
      //console.log("login results:", res.data);
      if(res.data.status === "ok" && res.data.user && res.data.user.userKey) {
        if(res.data.user.isActive !== 1) {
          //console.log("no longer active");
          //show errors
          setErrors(['This account is no longer active']);
        }
        else {
          //store user in memory
          /*let user = {
            userKey: res.data.user.userKey.
            email: res.data.user.email,
            firstName: res.data.user.firstName,
            lastName: res.data.user.lastName,
          }*/
          //console.log('about to set client cookie');
          //set cookie
          setAuthentication(res.data.user, persist);

          //dispatch?
          dispatch(saveUserStore(res.data.user));

          //console.log('redirect home');
          //redirect
          //setLoginSuccess(true);
          //setAuth(true);
          if(inviteKey != null){
            navigate(`/account/${res.data.user.defaultAccountKey}/profile`);
          } else {
            navigate(`/account/${res.data.user.defaultAccountKey}`);
          }
          

        }
      }
      else {
        //console.log('an error was returned');
        //display errors
        clearAuthentication();

        dispatch(clearUserStore());

        let errorMsgs = [];
        res.data.errors.forEach((error, i) => {
          switch (error) {
            case 'email-missing':
              errorMsgs.push('Please enter an email.');
              break;
            case 'password-missing':
              errorMsgs.push('Please enter a password.');
              break;
            case 'reg-not-found':
              errorMsgs.push('The AWS Marketplace registration was not found.');
              break;
            case 'reg-already-registered':
              errorMsgs.push('An account has already been created for this AWS Marketplace registration.');
              break;
            case 'no-user':
              errorMsgs.push('Please enter a valid login.');
              break;
            case 'invalid-password':
              errorMsgs.push('Please check your password and try again.');
              break;
            default:
              errorMsgs.push('There was an error logging in. Try again later.');
          }
        });
        setErrors(errorMsgs);
      }
    })
    .catch((err) => {
      //console.error(err);
      //console.log('something went wrong');
      clearAuthentication();
      dispatch(clearUserStore());
      setErrors(['An error occured while logging in. Try again later.']);
    });
  }

  //check if logged in
  //<Redirect to="/"/>
  return (
    <Col xs={10} sm={8} md={6} className="public-component">
      <h3>Login</h3>
      <p>
        Login using the form below or <Link to={`/signup${params != '' ? '?' + params : ''}`}>sign up</Link> for an account.
      </p>
      {
        errors.length > 0 ? (
          <Alert variant='danger'>
          {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
          </Alert>
        ) : (null)
      }
    <Formik validationSchema={validationSchema}
      onSubmit={submitLogin}
      initialValues={{email:'',password:'',persist:false}}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        isValid,
        errors
      }) => (
        <Form noValidate onSubmit={handleSubmit} className='col-md-7 col-sm-8'>
          <Form.Group controlId='login-email' className='mb-3'>
            <Form.Label>Email</Form.Label>
            <Form.Control type="email" placeholder="email"
              name="email" value={values.email} onChange={handleChange}
              isInvalid={touched.email && errors.email}
            />
            <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId='login-password' className='mb-3'>
            <Form.Label>Password</Form.Label>
            <Form.Control type="password" placeholder="password"
              name="password" value={values.password} onChange={handleChange}
              isInvalid={touched.password && errors.password}
            />
            <Form.Control.Feedback type="invalid">{errors.password}</Form.Control.Feedback>
          </Form.Group>
          {/*<Form.Group controlId='login-persist'>
            <Form.Check type="checkbox" name="persist" label="Stay logged in" onChange={handleChange} value={true}/>
          </Form.Group>*/}
          <Button variant="primary" type="submit">Login</Button>
        </Form>
      )}
    </Formik>
    {showPasswordReset === true ? (
      <div className='mt-3 text-center'>
      <Link to='/forgot'><small>Forgot Password</small></Link>
      </div>
    ) : null}

    </Col>
  );
}


export default Login;
